import MiBadge from './MiBadge.vue'

export default MiBadge
